import script from "./ProcEditHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcEditHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProcEditHeader.vue?vue&type=style&index=0&id=6cb97422&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb97422"]])

export default __exports__